export var CC_FORM = 'creditCardForm';
export var CC_LOADER = 'creditCardLoader';
export var CC_ERROR_BOUNDARY = 'creditCardErrorBoundary';
export var CC_STATE_PROVIDER = 'creditCardStateProvider';
export var CC_ERROR_MESSAGE = 'creditCardErrorMessage';